import { DomainDTO } from '@/dtos'

export class DomainResultDTO extends DomainDTO {
  constructor(name: string) {
    super('-1', name, 1, false, false, false)
  }
}
